// Dashboard Mockup - Abstract analytics visualization
export const DashboardMockup = () => (
  <div className="relative w-full h-full min-h-[200px] flex items-center justify-center overflow-hidden p-4">
    {/* Dashboard frame */}
    <div className="w-full max-w-sm bg-card/50 rounded-xl border border-border/50 p-3 backdrop-blur-sm">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-secondary animate-bento-pulse" />
          <span className="text-xs font-medium text-muted-foreground">Live Dashboard</span>
        </div>
        <div className="flex gap-0.5">
          <div className="w-1.5 h-1.5 rounded-full bg-green-500" />
          <div className="w-1.5 h-1.5 rounded-full bg-yellow-500" />
          <div className="w-1.5 h-1.5 rounded-full bg-red-500" />
        </div>
      </div>

      {/* Chart lines */}
      <div className="relative h-20 mb-3">
        <svg className="w-full h-full" viewBox="0 0 200 80" preserveAspectRatio="none">
          {/* Grid lines */}
          <line x1="0" y1="20" x2="200" y2="20" stroke="currentColor" strokeOpacity="0.08" />
          <line x1="0" y1="40" x2="200" y2="40" stroke="currentColor" strokeOpacity="0.08" />
          <line x1="0" y1="60" x2="200" y2="60" stroke="currentColor" strokeOpacity="0.08" />

          {/* Primary line */}
          <path
            d="M0,60 Q30,50 60,45 T120,30 T180,20 T200,15"
            fill="none"
            stroke="var(--secondary-hex)"
            strokeWidth="1.5"
            className="animate-bento-pulse"
          />

          {/* Secondary line */}
          <path
            d="M0,70 Q40,65 80,55 T140,45 T200,35"
            fill="none"
            stroke="var(--primary-hex)"
            strokeWidth="1.5"
            strokeOpacity="0.4"
          />
        </svg>

        {/* Data points */}
        <div className="absolute top-2 right-4 animate-bento-float">
          <div className="w-2.5 h-2.5 rounded-full bg-secondary shadow-lg shadow-secondary/50" />
        </div>
      </div>

      {/* Metrics row */}
      <div className="grid grid-cols-3 gap-1.5">
        <div className="text-center p-1.5 rounded-lg bg-background/50">
          <div className="text-sm font-bold text-secondary">↗ 24%</div>
          <div className="text-[10px] text-muted-foreground">Growth</div>
        </div>
        <div className="text-center p-1.5 rounded-lg bg-background/50">
          <div className="text-sm font-bold text-primary">847</div>
          <div className="text-[10px] text-muted-foreground">Visits</div>
        </div>
        <div className="text-center p-1.5 rounded-lg bg-background/50">
          <div className="text-sm font-bold text-grow">€2.4k</div>
          <div className="text-[10px] text-muted-foreground">Revenue</div>
        </div>
      </div>
    </div>
  </div>
);
